<template>
  <div class="TopPrompt">
    <div class="container_w clear">
        <div class="left">
            <a-carousel autoplay :dots=false dotPosition="right">
                <router-link 
                    v-for="(item,index) in messageList" :key="index"
                    :to="{path:'/news/newsdetails',query: {fileText: item.fileText,title:item.title}}"
                    >
                    <p class="ellipsis">{{item.title?item.title:item.nodeTitle}}</p>
                </router-link>
            </a-carousel>
        </div>
        
        <span class="right"><router-link to="/news">View More</router-link></span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  name: 'TopPrompt',
  data () {
    return {
        messageList:[]
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    
  },
  filters: {

  },
  computed: {

  },
  created () {
      console.log(BROADCASTJSON,'999999')
    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    let list = []
    BROADCASTJSON[0].childrens.forEach((i)=>{
        if(i.officeIdStr){
            if(i.officeIdStr.indexOf(OfficeID) >-1){
                list.push(i)
            }
        }
        // else{
        //     list.push(i)
        // }
    })
    // NEWSJSON[0].childrens.forEach((i)=>{
    //     if(i.officeIdStr){
    //         if(i.officeIdStr.indexOf(OfficeID) >-1){
    //             list.push(i)
    //         }
    //     }else{
    //         list.push(i)
    //     }
    // })
    console.log(list)
    this.messageList = list
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .TopPrompt{
        height:50px;
        background:rgba(254,249,213,1);
        overflow: hidden;
        display: flex;
        align-items: center;

        .left{
            margin-top: 0;
            line-height: 24px;
            position: relative;
            display: flex;
            align-items: center;

            &::before{
                content: '';
                background: url(../../assets/home/icon_com_news.png) no-repeat center;
                background-size: 100% 100%;
                width: 24px;
                height: 24px;
                margin-right: 8px;
                flex-shrink: 0;
            }

            .ant-carousel{
                float: left;
                height: 24px;

                &::v-deep .slick-list,
                &::v-deep .slick-track,
                &::v-deep .slick-slide,
                &::v-deep .slick-slide > div {
                    height: 24px !important;
                }

                &::v-deep .slick-list{
                    width: 612px;
                }

                &::v-deep .slick-slide{
                    overflow: hidden;

                    p{
                        width: 612px!important;
                        font-size:16px;
                        color:rgba(51,51,51,1);
                        cursor: pointer;
                        line-height: 24px;
                        margin: 0;
                    }
                }
            }
        }
        
        span{
            font-size:14px;
            color:rgba(216,0,15,1);
            line-height:16px;
            cursor: pointer;
            &::after{
                content: '';
                float: right;
                width: 16px;
                height: 16px;
                background: url(../../assets/home/icon_com_sj_morered.png) no-repeat center;
                background-size: 100% 100%;
            }
        }
        
    }
</style>
